var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    id: "Flat",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M212.00781,88a3.98323,3.98323,0,0,0-1.21924-2.86768l-55.958-55.958a4.04763,4.04763,0,0,0-.60694-.49805c-.05029-.03369-.10742-.05518-.15918-.08643a3.95219,3.95219,0,0,0-.52734-.28173c-.07617-.03174-.15869-.04639-.23682-.07325a3.93378,3.93378,0,0,0-.50927-.15527A3.995,3.995,0,0,0,152,28H55.99219a12.01312,12.01312,0,0,0-12,12V216a12.01312,12.01312,0,0,0,12,12H200a12.01312,12.01312,0,0,0,12-12V88.07764C212.00049,88.05078,212.00781,88.02637,212.00781,88ZM156,41.65723,198.34277,84H156ZM200,220H55.99219a4.004,4.004,0,0,1-4-4V40a4.004,4.004,0,0,1,4-4H148V88a4.0002,4.0002,0,0,0,4,4h52V216A4.004,4.004,0,0,1,200,220Zm-44-68a4.0002,4.0002,0,0,1-4,4H132v20a4,4,0,0,1-8,0V156H104a4,4,0,0,1,0-8h20V128a4,4,0,0,1,8,0v20h20A4.0002,4.0002,0,0,1,156,152Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/add-file.25c3ec7877af90867351db208db3fa57.svg";
export { ForwardRef as ReactComponent };